<template>
  <div id="scrap-history">
    <Table :columns="columns" :data="tableData" stripe border highlight-row max-height="600">
        <template slot-scope="{ row, column, index }" slot="propsCell">
          {{_.get(row, column.key)}}
        </template>
        <template slot-scope="{ row, column, index }" slot="baseInfoCell">
          <div>
              <div>
                <p>{{ row.part_number }}</p>
                <p>{{ row.brand }} <span
                  v-if="(row.source_model && row.source_model.component_type === 'electronic_part') || !row.manufacturer_part_id">{{ row.mpn }}</span>
                </p>
                <p>{{ row.name }}</p>
                <p
                  v-if="(row.source_model && row.source_model.component_type !== 'electronic_part') || !row.manufacturer_part_id">
                  {{ row.specification }}
                </p>
              </div>
            </div>
        </template>
        <template slot-scope="{ row, column, index }" slot="bomInfoCell"></template>
        <template slot-scope="{ row, column, index }" slot="actionCell">
          <div>
            <Tooltip content="Edit" transfer>
              <Icon type="md-create" color="#2D8cF0" size="14" class="cursor" @click="handleEditScrap"/>
            </Tooltip>
            <Tooltip content="Look history" transfer>
              <Icon type="md-timer" class="margin-left-10 cursor" color="#2D8cF0" size="14" @click="handleShowHistory"/>
            </Tooltip>
          </div>
        </template>
      </Table>
  </div>
</template>

<script>
export default {
  name: 'ScrapHistory',
  prop: {
    id: {
      type: [Number, String],
      require: true
    }
  },
  data() {
    return {
      tableData: [],
      columns: [
        {
          type: 'index',
          width: 50,
          align: 'center'
        },
        {
          key: 'part_number',
          title: 'Part number',
          align: 'left',
          minWidth: 160
        },
        {
          key: 'mpn',
          title: 'mpn',
          align: 'left',
          minWidth: 80
        },
        {
          key: 'specification',
          title: 'Specification',
          align: 'left',
          minWidth: 160
        },
        {
          key: 'scrap',
          title: 'Scrap(%)',
          align: 'left',
          minWidth: 160
        },
        {
          key: 'note',
          title: 'Notes',
          align: 'left',
          minWidth: 160
        },
        {
          key: 'operator',
          title: 'Operator',
          align: 'left',
          minWidth: 80
        },
        {
          key: 'date',
          title: 'Date',
          align: 'left',
          minWidth: 80
        }
      ]
    }
  },
  methods: {}
}
</script>

<style>
</style>
